const READINESS = {
  OTP_INPUT: (_body, state) => state?.otp?.length === 6,
};

const isAnyFieldDisabled = (body) =>
  (body?.fields ?? []).some((f) => f?.disabled);

export const isBodyReady = (body, state) => {
  if (isAnyFieldDisabled(body)) return false;
  const fn = READINESS[body?.type];
  return fn ? fn(body, state) : true;
};
